import type { TOC } from '@ember/component/template-only'
import { HomeTile } from 'teacher-ui-client/components/home/tile'

const titles = {
  welcome: 'Welcome to Writing Legends',
  gettingStarted: 'Getting Started with Writing Legends',
  excitingIdeas: 'Writing Legends: Exciting Writing Ideas',
  lessons: 'Writing Legends: Lessons',
  realms: 'Writing Legends: Realms',
}

export const PromoVideos: TOC<object> = <template>
  <HomeTile>
    <iframe
      class="snappy:invisible h-56 w-full"
      src="https://www.youtube.com/embed/xEqB5UAeUhY"
      title={{titles.welcome}}
      frameborder="0"
      allowfullscreen
    ></iframe>
  </HomeTile>
  <HomeTile>
    <iframe
      class="snappy:invisible h-56 w-full"
      src="https://www.youtube.com/embed/YUwB3E7kkQY"
      title={{titles.gettingStarted}}
      frameborder="0"
      allowfullscreen
    ></iframe>
  </HomeTile>
  <HomeTile>
    <iframe
      class="snappy:invisible h-56 w-full"
      src="https://www.youtube.com/embed/f5lN1aUWkSU"
      title={{titles.excitingIdeas}}
      frameborder="0"
      allowfullscreen
    ></iframe>
  </HomeTile>
  <HomeTile>
    <iframe
      class="snappy:invisible h-56 w-full"
      src="https://www.youtube.com/embed/-ItI1OP6Ze0"
      title={{titles.lessons}}
      frameborder="0"
      allowfullscreen
    ></iframe>
  </HomeTile>

  <HomeTile>
    <iframe
      class="snappy:invisible h-56 w-full"
      src="https://www.youtube.com/embed/kJUFHmvmmiM"
      title={{titles.realms}}
      frameborder="0"
      allowfullscreen
    ></iframe>
  </HomeTile>
</template>

export default PromoVideos
